const indexItems = [
  {
    title: '恋爱韩漫',
    count: '856部',
    icon: 'ri-heart-line',
    color: 'bg-accent-500',
    desc: '甜蜜恋爱与心动剧情',
  },
  {
    title: '奇幻韩漫',
    count: '624部',
    icon: 'ri-magic-line',
    color: 'bg-primary-500',
    desc: '异世界冒险与魔法',
  },
  {
    title: '动作韩漫',
    count: '512部',
    icon: 'ri-sword-line',
    color: 'bg-secondary-500',
    desc: '热血战斗与成长',
  },
  {
    title: '悬疑韩漫',
    count: '398部',
    icon: 'ri-search-eye-line',
    color: 'bg-accent-600',
    desc: '烧脑推理与反转',
  },
  {
    title: 'BL韩漫',
    count: '476部',
    icon: 'ri-user-heart-line',
    color: 'bg-primary-600',
    desc: '高人气纯爱作品',
  },
  {
    title: '完结韩漫',
    count: '1200+部',
    icon: 'ri-check-double-line',
    color: 'bg-secondary-600',
    desc: '一次性畅读全集',
  },
  {
    title: '新番速递',
    count: '86部',
    icon: 'ri-rocket-line',
    color: 'bg-accent-500',
    desc: '最新连载抢先看',
  },
  {
    title: '经典必读',
    count: '200部',
    icon: 'ri-star-line',
    color: 'bg-primary-500',
    desc: '口碑神作合集',
  },
];

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            按分类快速找到你喜欢的韩漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl ${item.color}/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg ${item.color.replace('bg-', 'text-')}`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-600">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}